export default __webpack_public_path__ + "static/media/XPBANNER-w-o-words.c870b06a.jpg";